import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { parseNumToFixed } from "../../../../utils/common";
import Select from 'react-select';
import { postsIds, roleId } from "../../../../constants/app";
import moment from "moment";
import { useSelector } from "react-redux";
import swal from 'sweetalert';

function PrizeTable({stylesTable, staff, staffData, onSavePrize, onDeletePrize, onAddPrize, startOfMonthDate, isBlockFirst, isBlockSecond, type}) {
    const user = useSelector(state => state.user.info);

    const [newPrize, setNewPrize] = useState(false);
    const [data, setData] = useState(null);

    const [prizesData, setPrizesData] = useState([]);

    const getPrizes = () => {
        if (isEmpty(staff)) return;
        const staffWithPrize = (staffData || []).filter((item) => !isEmpty((item.prize)));

        if (isEmpty(staffWithPrize)) return;
        const prizes = staffWithPrize.flatMap((item) => {
            const post = postsIds.find((p) => p.id === item.postId);
            const entityStaff = staff.find((s) => s.id === item.staffId);
            const name = entityStaff && entityStaff.name ? entityStaff.name : item.name;
            return item.prize.filter((prize) => !prize.isDeleted && prize.type === type).map((prize, index) => ({ ...prize, index, name, staffId: item.staffId, id: item.id, post })).sort((a, b) => new Date(a.date) - new Date(b.date));
        });
        return prizes;
    }

    useEffect(() => {
        setPrizesData(getPrizes())
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [staff, staffData]);
    
    const onChangePrize = (value, field, id, index) => {
        const updated = prizesData.map((item) => (item.id === id && item.index === index) ? { ...item, [field]: value, isChange: true } : item );
        setPrizesData(updated);
    }

    const onChangeStaffPrize = (e, id, index) => {
        if (!e || !e.value || !e.label) return;
        const post = e.postId ? postsIds.find((p) => p.id === e.postId) : null;
        const updated = prizesData.map((item) => (item.id === id && item.index === index) ? { ...item, name: e.label, staffId: e.value, postId: e.postId, post, isChange: true, isChangeStaff: true } : item );
        setPrizesData(updated);
    }

    const handleOpenNewPrize = () => {
        setData({
            id: null,
            name: null,
            staffId: null,
            post: null,
            date: moment().format('YYYY-MM-DD'),
            sum: 0,
            type,
            comment: null,
        });
        setNewPrize(true);
    };

    const onChangeNewPrize = (value, field) => {
        const updated = {...data};
        updated[field] = value;
        setData(updated);
    };

    const onChangeStaffNewPrize = (e) => {
        if (!e || !e.value || !e.label) return;

        const post = e.postId ? postsIds.find((p) => p.id === e.postId) : null;

        const updated = {
            ...data,
            name: e.label,
            staffId: e.value,
            postId: e.postId,
            post
        };

        setData(updated);
    };

    const handleSavePrize = (id) => {
        const changedPrizes = prizesData.filter((prize) => prize.id === id && prize.isChange);
        if (isEmpty(changedPrizes)) return;
        onSavePrize(changedPrizes);
    }

    const handleSaveNewPrize = () => {
        onAddPrize(data);
        setNewPrize(false);
        setData(null);
    }

    const isValidNewPrize = () => {
        const { staffId, postId, date, type, sum } = data;
        if (staffId && postId && date && !isEmpty(type) && sum != null && sum !== 0) return true;
        return false;
    }

    const handleDeletePrize = (id, index) => {
        return swal({
            title: `Удаление ${type === 'prize' ? 'премии' : 'депремирования'}`,
            text: `Вы уверены, что хотите удалить данные? Это действие необратимо.`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) onDeletePrize(id, index);
        });
    }

    const handleDeleteNewPrize = () => {
        setNewPrize(false);
        setData(null);
    }

    const getStaffName = (item) => {
        if (!item) return;
        if (item.actualName) return item.actualName;
        if (item.staffId) {
            const entity = staff.find((el) => el.id === item.staffId);
            if (entity) return entity.name;
        }
        return item.name;
    }

    const minDate = startOfMonthDate ? moment(startOfMonthDate).add(isBlockFirst ? 15 : 0, 'days').format('YYYY-MM-DD') : null;
    const maxDate = startOfMonthDate ? moment(startOfMonthDate).endOf('month').format('YYYY-MM-DD') : null;

    const staffOptions = (staffData || [])
    .map((item) => ({ value: item.staffId, label: getStaffName(item), postId: item.postId }));

    const renderNewPrize = () => {
        return (
            <tr className="kt-datatable__row" style={{ ...stylesTable.outline}}>
                <td style={{ ...stylesTable.lg, ...stylesTable.textStart }} className="kt-datatable__cell">
                    <Select
                        value={(data && data.staffId) ? { value: data.staffId, label: data.name } : null}
                        closeMenuOnSelect={true}
                        options={staffOptions.filter((option) => option.value !== data.staffId)}
                        onChange={(e) => onChangeStaffNewPrize(e)}
                        placeholder="Сотрудник"
                        noOptionsMessage={() => 'Сотрудники не найдены'}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        menuPlacement="auto"
                        menuPosition="fixed" 
                    />
                </td>
                <td style={{ ...stylesTable.lg, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    {(data.post && data.post.label) ? data.post.label : '-'}
                </td>
                <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    <input
                        min={minDate}
                        max={maxDate}
                        style={{ ...stylesTable.input }} 
                        type='date'
                        value={data.date}
                        onChange={(e) => onChangeNewPrize(e.target.value, 'date')}
                    />
                </td>
                <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    <input
                        onFocus={(e) => e.target.select()}
                        className="no-number-spinner"
                        style={{ ...stylesTable.input }} 
                        value={data.sum}
                        type="number"
                        min={0}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value > 0) return onChangeNewPrize(parseNumToFixed(value), 'sum');
                            return onChangeNewPrize(0, 'sum');
                        }}
                    />
                </td>
                <td style={{ ...stylesTable.lg, ...stylesTable.borderLeft, ...stylesTable.textStart }} className="kt-datatable__cell">
                    <input
                        style={{ ...stylesTable.input }} 
                        value={data.comment}
                        onChange={(e) => onChangeNewPrize(e.target.value, 'comment')}
                    />
                </td>
                <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    <div style={{ display: 'flex', gap: '10px' }}>
                    <button type='button' disabled={!isValidNewPrize()} onClick={handleSaveNewPrize} className="btn btn-success btn-sm btn-icon"><i className="flaticon2-check-mark"/></button>
                    <button type='button' onClick={handleDeleteNewPrize} className="btn btn-danger btn-sm btn-icon"><i className="flaticon2-trash"/></button>
                    </div>
                </td>
            </tr>
        );
    }

    const renderPrizes = (item) => {
        return (
            <tr className="kt-datatable__row" style={{ ...stylesTable.outline}}>
                <td style={{ ...stylesTable.lg, ...stylesTable.textStart }} className="kt-datatable__cell">
                    <Select
                        isDisabled={moment(item.date).date() > 15 ? isBlockSecond : isBlockFirst}
                        value={{ value: item.staffId, label: item.name }}
                        closeMenuOnSelect={true}
                        options={staffOptions.filter((option) => option.value !== item.staffId)}
                        onChange={(e) => onChangeStaffPrize(e, item.id, item.index)}
                        placeholder="Сотрудник"
                        noOptionsMessage={() => 'Сотрудники не найдены'}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        menuPlacement="auto"
                        menuPosition="fixed" 
                    />
                </td>
                <td style={{ ...stylesTable.lg, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    {(item.post && item.post.label) ? item.post.label : '-'}
                </td>
                <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    <input
                        min={minDate}
                        max={maxDate}
                        style={{ ...stylesTable.input }} 
                        type='date'
                        value={item.date}
                        onChange={(e) => onChangePrize(e.target.value, 'date', item.id, item.index)}
                    />
                </td>
                <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    <input
                        disabled={moment(item.date).date() > 15 ? isBlockSecond : isBlockFirst}
                        onFocus={(e) => e.target.select()}
                        className="no-number-spinner"
                        style={{ ...stylesTable.input }} 
                        value={item.sum}
                        min={0}
                        type="number"
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value > 0) return onChangePrize(parseNumToFixed(value), 'sum', item.id, item.index);
                            return onChangePrize(0, 'sum', item.id, item.index);
                        }}
                    />
                </td>
                <td style={{ ...stylesTable.lg, ...stylesTable.borderLeft, ...stylesTable.textStart }} className="kt-datatable__cell">
                    <input
                        disabled={moment(item.date).date() > 15 ? isBlockSecond : isBlockFirst}
                        style={{ ...stylesTable.input }} 
                        value={item.comment}
                        onChange={(e) => onChangePrize(e.target.value, 'comment', item.id, item.index)}
                    />
                </td>
                <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button type='button' disabled={!item.isChange} onClick={() => handleSavePrize(item.id)} className="btn btn-success btn-sm btn-icon"><i className="flaticon2-check-mark"/></button>
                        <button type='button' onClick={() => handleDeletePrize(item.id, item.index)} className="btn btn-danger btn-sm btn-icon"><i className="flaticon2-trash"/></button>
                    </div>
                </td>
            </tr>
        );
    }

    const renderBody = () => {
        return (
            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded' style={{ width: 'max-content', overflow: 'auto' }}>
                <table className='kt-datatable__table' style={{ width: '100%' }}>
                    <tbody className='kt-datatable__body' style={{ padding: '5px' }}>
                        <tr className="kt-datatable__row" style={{ backgroundColor: '#CCCCCC', ...stylesTable.outline}}>
                            <td style={{ ...stylesTable.lg, ...stylesTable.textStart }} className="kt-datatable__cell">
                                Сотрудник
                            </td>
                            <td style={{ ...stylesTable.lg, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                                Должность
                            </td>
                            <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                                Дата
                            </td>
                            <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                                Сумма
                            </td>
                            <td style={{ ...stylesTable.lg, ...stylesTable.borderLeft, ...stylesTable.textStart }} className="kt-datatable__cell">
                                Комментарий
                            </td>
                            <td style={{ ...stylesTable.md, ...stylesTable.borderLeft, ...stylesTable.textStart }} className="kt-datatable__cell" >
                                Действия
                            </td>
                        </tr>
                        {!isEmpty(prizesData) && prizesData.filter((prize) => !prize.isDeleted && !prize.isDelete && !prize.isSend).map((prize) => renderPrizes(prize))}
                        {!newPrize && user.role.id !== roleId.cashier && !isBlockSecond &&
                            <tr>
                                <td style={ stylesTable.lg }>
                                    <button type='button' onClick={handleOpenNewPrize} className="btn btn-sm btn-icon btn-primary" style={{ height: '22px', width: '40%' }}>
                                        <i className="flaticon2-plus" />
                                    </button>
                                </td>
                            </tr>
                        }
                        {newPrize && renderNewPrize()}
                    </tbody>
                </table>
            </div>
        );
    }

    return (
        <>
        {renderBody()}
        </>
    );
}


export default PrizeTable;